import React, { Component } from 'react';
import IconSVG from 'svg-inline-react'

import './ConsultBlock.scss';


class ConsultBlock extends Component {
    render() {
        return (
            <div className="ConsultBlock-additional">
                <div className="blockPhone">
                    <h4>Остались вопросы? Позвоните нам</h4>

                    <div className="blockPhone-content">
                        <IconSVG
                            className="blockPhone-icon"
                            src={require('!svg-inline!./call-icon.svg')}/>

                        <div className="blockPhone-consult">
                            <span>Бесплатный номер для консультации</span>
                            <a href="tel:+79188900295">+7 (918) 890-02-95</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ConsultBlock;



// WEBPACK FOOTER //
// ./client/components/ConsultBlock/ConsultBlock.js